<!--
 * @Descripttion: 服务商场景策划列表
 * @Date: 2026-07-24
-->
<template>
  <div class="scene-provider-planning">
    <XrkTable
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></XrkTable>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  useTableColumn,
  useSelectColumn,
  useDatePickerColumn,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils/';
import { sceneManagePage } from '../data-source/apis';
import { deptListPageCmb } from '@/views/form-manage/src/data-source/apis';
import type { SceneManageListItem } from '../data-source/types';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);
const router = useRouter();
const xrkTableRef = ref<XrkTableRef>(null);

// 搜索项
const searchConfig: XrkTableProps['searchConfig'] = {
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useSelectColumn({
      prop: 'industryId',
      label: '工业名称',
      config: {
        placeholder: '请选择工业名称',
        clearable: true,
        filterUseRemote: true,
        labelKey: 'entpName',
        valueKey: 'deptId',
        remoteMethod: (name: string) =>
          deptListPageCmb({
            pageNum: 1,
            pageSize: 50,
            enterpriseName: name || '',
            aspId: userInfo.value.finalDepId
          }).then((res: any) => {
            const list = res?.data?.list || [];
            // 只保留工业（functionCode=1），过滤服务商/供应商
            res.data.list = list.filter((e: any) => +e.functionCode === 1);
            return res;
          })
      }
    }),
    useDatePickerColumn({
      prop: 'updateDt',
      label: '最近更新时间',
      config: {
        type: 'daterange',
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        clearable: true
      },
      style: { width: '240px' },
      listener: {
        onChange: (...restParams: any[]) => {
          const [activeValue, searchData] = restParams;
          const [start, end] = activeValue || [undefined, undefined];
          Object.assign(searchData, { updateDtStart: start, updateDtEnd: end });
        }
      }
    })
  ] as any[],
  otherComponents: [
    {
      render() {
        return (
          <BaseButton type="primary2" onClick={() => onOpenCreate('manual')}>
            新建
          </BaseButton>
        );
      }
    }
  ]
};

// 列表
const tableConfig: XrkTableProps['tableConfig'] = {
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: 80
    }),
    useTableColumn({
      label: '工业名称',
      prop: 'industryName',
      minWidth: 200
    }),
    useTableColumn({
      label: '推荐场景数',
      prop: 'sceneCount',
      align: 'right',
      width: 120
    }),
    useTableColumn({
      label: '最近更新时间',
      prop: 'updateDt',
      minWidth: 180,
      formatter: ({ cellValue }: { cellValue: string }) =>
        formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handle',
      fixed: 'right',
      width: 80,
      render: ({ row }: { row: SceneManageListItem }) => {
        return (
          <div style="display: flex; gap: 8px;">
            <BaseButton link type="primary2" onClick={() => onViewDetail(row)}>
              查看明细
            </BaseButton>
          </div>
        );
      }
    })
  ] as any[]
};

/** 获取列表数据（aspId 由后端根据当前登录信息自动获取，前端不传） */
const getListAjax = async (params: Record<string, any>) => {
  // @TODO OSS: aspId 从搜索栏选择的服务商取；IAS: 从当前企业 store 取
  return sceneManagePage({
    planScope: 2,
    pageNum: params.pageNum,
    pageSize: params.pageSize,
    aspId: params.aspId,
    industryId: params.industryId,
    createType: params.createType,
    // source：OSS 固定 1（平台）；IAS 按 functionCode（服务商=2 / 工业=3）
    source: (userInfo.value as any)?.functionCode === 2 ? 2 : 3,
    updateDtStart: params.updateDtStart,
    updateDtEnd: params.updateDtEnd
  });
};

const onOpenCreate = (type: string) => {
  if (type === 'manual') {
    router.push({ name: 'scene-mgmt-a-plan-manual' });
  }
};
/** 查看明细 */
const onViewDetail = (row: SceneManageListItem) => {
  router.push({
    name: 'scene-mgmt-a-plan-manual',
    query: {
      planId: String(row.planId),
      industryId: String(row.industryId),
      aspId: row.aspId
    }
  });
};
</script>
<style lang="scss" scoped>
.notice-bar {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  padding: 10px 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.6;
}
.notice-bar strong {
  color: #374151;
}
</style>
